import { Fragment, useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { LoadingSpinnerOverlayRegular } from "./LoadingSpinnerOverlayRegular";
import { ModalErrorStyles } from "./ModalErrorStyles";
import "./ModalCommunication.scss";

interface ModalCommunication3Props {
  otherModalOpen: boolean;
}

export const ModalCommunication3 = (props: ModalCommunication3Props) => {
  const { otherModalOpen } = props;
  const classes = ModalErrorStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [isSmallWidth, setIsSmallWidth] = useState<boolean>(false);
  const [isMediumWidth, setIsMediumWidth] = useState<boolean>(false);
  const [clicked, setClicked] = useState<boolean>(false);
  const [loadedImg, setLoadedImg] = useState<boolean>(false);

  useEffect(() => {
    const tmsp: { openTmsp: number } =
      JSON.parse(localStorage?.getItem("azumeConecta1Tmsp")) || {};
    const clk: { clicked: boolean } =
      JSON.parse(localStorage?.getItem("azumeConecta1Clicked")) || {};
    const now = new Date().getTime();

    if (!tmsp?.openTmsp || now >= tmsp?.openTmsp) {
      var timer = setTimeout(() => {
        setOpen(true && !otherModalOpen);
      }, 3000);
    }

    if (!!clk?.clicked) {
      setClicked(true);
    }

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
    resizeHandler();

    var timer = setTimeout(() => {
      resizeHandler();
    }, 1000);

    return () => {
      window.removeEventListener("resize", resizeHandler);
      clearTimeout(timer);
    };
  }, []);

  const resizeHandler = () => {
    if (window.innerWidth < 600) {
      setIsSmallWidth(true);
    } else {
      setIsSmallWidth(false);
    }

    if (window.innerWidth < 1000) {
      setIsMediumWidth(true);
    } else {
      setIsMediumWidth(false);
    }
  };

  const closeHandler = () => {
    if (loadedImg) {
      const now = new Date().getTime();

      localStorage.setItem(
        "azumeConecta1Tmsp",
        JSON.stringify({ openTmsp: now + 7 * 24 * 60 * 60 * 1000 })
      );
      setOpen(false);
    }
  };

  const denyHandler = () => {
    if (loadedImg) {
      const now = new Date().getTime();
      // window.open("https://assineazume.com.br/ebook-fiob", "_blank");
      localStorage.setItem(
        "azumeConecta1Tmsp",
        JSON.stringify({ openTmsp: now + 90 * 24 * 60 * 60 * 1000 })
      );
      setOpen(false);
    }
  };

  const agreeHandler = () => {
    if (loadedImg) {
      setClicked(true);
      localStorage.setItem(
        "azumeConecta1Clicked",
        JSON.stringify({ clicked: true })
      );
      window.open("https://form.respondi.app/PIyKdut2", "_blank");
    }
  };

  return (
    <Dialog
      className={classes.modalCommunicationContainer}
      style={{ zIndex: 502 }}
      open={open}
      onClose={closeHandler}
    >
      {!loadedImg && <LoadingSpinnerOverlayRegular />}
      <DialogActions style={{ paddingBottom: 0 }}>
        <Button style={{ height: "25px" }} size="small" onClick={closeHandler}>
          X
        </Button>
      </DialogActions>
      <DialogContent
        className={classes.modalCommunication}
        style={{ padding: 0, boxSizing: "border-box" }}
      >
        <div
          className="modal-communication__img-container"
          onClick={agreeHandler}
        >
          <img
            onLoad={() => {
              setLoadedImg(true);
            }}
            className="modal-communication__img"
            src={
              !isMediumWidth && !isSmallWidth
                ? `${process.env.PUBLIC_URL}/azume-conecta-1-lg.jpg`
                : isMediumWidth && !isSmallWidth
                ? `${process.env.PUBLIC_URL}/azume-conecta-1-md.jpg`
                : isMediumWidth && isSmallWidth
                ? `${process.env.PUBLIC_URL}/azume-conecta-1-sm.jpg`
                : `${process.env.PUBLIC_URL}/azume-conecta-1-lg.jpg`
            }
            alt=""
          />
        </div>
      </DialogContent>
      <div className="modal-communication__actions" style={{ paddingTop: 0 }}>
        <Button
          size={isSmallWidth ? "small" : "medium"}
          variant="outlined"
          color="secondary"
          onClick={denyHandler}
        >
          NÃO TENHO INTERESSE
        </Button>
        <Button
          size={isSmallWidth ? "small" : "medium"}
          variant="contained"
          color="primary"
          onClick={agreeHandler}
        >
          SAIBA MAIS
        </Button>
      </div>
    </Dialog>
  );
};
